'use strict';

wbApp.factory('activityInstructorSvc', ['$resource', '$q', '$translate', '$http', 'repositorySvc', 'notificationSvc',
function ($resource, $q, $translate, $http, repositorySvc, notificationSvc) {

    function createEmployeeModel(selectedSchedules) {
        return new webooker_acivity_models.Employee(selectedSchedules);
    }        

    function BuildWeekModel(activityinstructors, schedules) {
        var employeeHash = {};

        angular.forEach(activityinstructors, function (instructor, idx) {
            var employee = employeeHash[instructor.employeeID];
            if (!employee) {
                employee = createEmployeeModel(schedules);
                employeeHash[instructor.employeeID] = employee;
                employee.fullName = instructor.employeeFullName;
                employee.employeeID = instructor.employeeID;
                employee.activityID = instructor.activityID;
            }

            employee.schedules.push(instructor);
        });

        var ret = [];

        for (var employeeID in employeeHash) {
            ret.push(employeeHash[employeeID]);
        }

        return ret;
    }

    function getWeekModelByIntervals(semesterId, activityId, weeks) {
        var scheduleIDs = [];
        var schedules = [];

        angular.forEach(weeks, function (week, idx) {
            angular.forEach(week.schedules, function (schedule, sidx) {
                scheduleIDs.push(schedule.activityScheduleID);
                schedules.push(schedule);
            })
           
        });

        var deferred = $q.defer();
        var result = [];

        result.$promise = deferred.promise;

        if (scheduleIDs.length > 0) {
            $http({
                method: 'POST',
                url: '/Api/ActivityInstructors/GetAllBySchedules',
                data: {
                    semesterID: semesterId,
                    activityID: activityId,
                    schedules: scheduleIDs
                }
            })
            .success(function (data, status, headers, config) {

                var model = BuildWeekModel(data, schedules);

                result.push.apply(result, model);
                deferred.resolve(model);
            })
            .error(function (errorResult, status, headers, config) {
                deferred.reject(errorResult);
                if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_GET_ERROR'),
                        notificationSvc.translateError(errorResult.data));
                }
            });
        } else {
            deferred.resolve([]);
        }

        return result;
    }

    function getAllByEmployeeAndActivity(employeeID, activityID) {
        var deferred = $q.defer();
        var result = [];
        result.$promise = deferred.promise;

        $http({
            method: 'POST',
            url: '/Api/ActivityInstructors/GetAllByEmployeeAndActivity',
            data: {
                employeeID: employeeID,
                activityID: activityID
            }
        })
        .success(function (data, status, headers, config) {
            result.push.apply(result, data);
            deferred.resolve(result);
        })
        .error(function (errorResult, status, headers, config) {
            deferred.reject(errorResult);
            if (errorResult.status === 403) {
                notificationSvc.fatalNotify(
                    $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
            } else {
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_GET_ERROR'),
                    notificationSvc.translateError(errorResult.data));
            }
        });

        return result;
    }

    function createEmployeeDetailModel(instructors, schedules, employeeID, activityID)
    {
        return new webooker_acivity_models.EmployeeDetail(instructors, schedules, employeeID, activityID);
    }

    function saveAsync(instructors, employeeID, activityID) {
        var deferred = $q.defer();

        $http({
            method: 'POST',
            url: '/Api/ActivityInstructors/Save',
            data: {
                employeeID: employeeID,
                activityID: activityID,
                instructors: instructors || []
            }
        })
        .success(function (data, status, headers, config) {
            deferred.resolve(data);
            notificationSvc.notifyInfo(
                $translate.instant('TXT_ALERT_TITLE_ACTION_REGISTRATION_SUCCESS'));
        })
        .error(function (errorResult, status, headers, config) {
            deferred.reject(errorResult);
            if (errorResult.status === 403) {
                notificationSvc.fatalNotify(
                    $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
            } else {
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_GET_ERROR'),
                    notificationSvc.translateError(errorResult.data));
            }
        });

        return deferred.promise;
    }

    return {
        getWeekModelByIntervals: getWeekModelByIntervals,
        getAllByEmployeeAndActivity: getAllByEmployeeAndActivity,
        createEmployeeDetailModel: createEmployeeDetailModel,
        saveAsync: saveAsync
    }

}]);
